const replaceWithAmpersand = (original: string) => {
  return original.replace(new RegExp("and", "ig"), "&");
};

export { replaceWithAmpersand };
